export const siteBaseUrl = "https://www.vimplement.com";

export const homeContent = {
  no: {
    trustStrip: [
      "Grunnlegger-ledet levering",
      "Svar innen én virkedag",
      "Org. nr. 934 134 176",
      "Basert i Oslo",
    ],
    problemsTitle: "Hva vi rydder opp i",
    problemsSubtitle:
      "Gode leveranser starter med drift: hvilke steg tar tid, hvilke tall mangler, og hvor bør software eller AI overta uten å skape ny kompleksitet.",
    problems: [
      {
        icon: "repeat",
        title: "For mye manuelt etterarbeid",
        description:
          "Henvendelser, tilbud, dokumenter, booking og oppfølging lever i e-post, regneark og hukommelse. Vi bygger arbeidsflyter der ansvar, logging og neste steg er tydelig.",
      },
      {
        icon: "chart",
        title: "Tallene er spredt og lite handlingsorienterte",
        description:
          "Ledelsen trenger margin, kontantstrøm, pipeline, kapasitet og avvik i ett bilde. Vi kobler kildene sammen og gjør tallene brukbare i hverdagen.",
      },
      {
        icon: "link",
        title: "Systemene henger ikke sammen",
        description:
          "Nettside, CRM, økonomi, dokumenter og interne rutiner må spille sammen. Målet er en ryddig driftsflate – ikke enda et system uten eier.",
      },
    ],
    processTitle: "Slik gjennomføres oppdrag",
    processSubtitle:
      "Avgrensede leveranser med tydelig scope, målbart utbytte og direkte kontakt med den som bygger.",
    process: [
      {
        step: "01",
        title: "Kartlegging",
        description:
          "Vi går gjennom prosess, datakilder, ansvar og flaskehalser, og finner hvor software, data eller AI gir effekt først.",
      },
      {
        step: "02",
        title: "Løsningsutkast",
        description:
          "Du får et konkret forslag: scope, integrasjoner, risiko og hva som bør måles etter go-live.",
      },
      {
        step: "03",
        title: "Implementering",
        description:
          "Løsningen bygges, kobles sammen og dokumenteres. Drift, sikkerhet og eierskap er avklart før overlevering.",
      },
      {
        step: "04",
        title: "Stabilisering",
        description:
          "Etter lansering justeres løsningen mot faktisk bruk, ikke antakelser. Resultatet blir mer robust over tid.",
      },
    ],
    casesTitle: "Eksempler på leveranser",
    casesSubtitle:
      "Typiske oppdrag der vi kombinerer AI, styringsdata og praktisk software for norske SMB-er.",
    caseStudies: [
      {
        title: "Regnskapsmiljø med for mye manuell MVA-behandling",
        problem:
          "Transaksjoner måtte kategoriseres og kontrolleres manuelt før rapportering.",
        solution:
          "Automatisert kategorisering, API-kobling til økonomisystem og ryddigere kontrollflyt før innsending.",
        result:
          "Timer spart hver uke og bedre kontroll på rapporteringen.",
      },
      {
        title: "Ledelse som manglet ett samlet styringsbilde",
        problem:
          "Omsetning, varekost og driftstall lå i ulike systemer og regneark.",
        solution:
          "Bygget Power BI-basert ledelsesdashbord med tydelige KPI-er og datamodell.",
        result:
          "Raskere beslutninger og mindre tid brukt på manuell rapportpakking.",
      },
      {
        title: "Tjenestebedrift med utdatert booking- og leadflyt",
        problem:
          "Kundedialog og bestillinger kom inn via telefon, skjema og e-post uten en felles prosess.",
        solution:
          "Ny nettside, digital booking og strukturert oppfølging koblet til backoffice-rutiner.",
        result:
          "Flere digitale henvendelser og mindre administrativ friksjon i hverdagen.",
      },
    ],
    faqTitle: "Ofte stilte spørsmål",
    faqSubtitle:
      "Korte svar på det de fleste lurer på før første samtale.",
    faq: [
      {
        question: "Hvem passer dette best for?",
        answer:
          "Norske SMB-er med manuell administrasjon, svak rapportering, friksjon i kundedialogen eller økonomi- og driftsdata som ikke henger sammen.",
      },
      {
        question: "Hvor raskt kan et oppdrag starte?",
        answer:
          "Avhenger av omfang. Mindre kartlegginger og avgrensede leveranser starter ofte raskt. Første steg er en kort samtale om behov, systemer og ønsket effekt.",
      },
      {
        question: "Er dette programvare eller konsulenttimer?",
        answer:
          "Begge deler, pakket som konkrete leveranser. Du får en fungerende arbeidsflyt, rapport eller softwarekomponent – ikke løse timer uten sluttprodukt.",
      },
      {
        question: "Jobber dere bare med Microsoft-teknologi?",
        answer:
          "Microsoft er ofte et naturlig utgangspunkt, men løsningen tilpasses systemene du allerede bruker. Vi tvinger ikke frem en bestemt stack.",
      },
      {
        question: "Kan dere hjelpe både med strategi og gjennomføring?",
        answer:
          "Ja. Mange oppdrag starter med å prioritere hva som bør gjøres først, og går videre til implementering, dokumentasjon og stabilisering.",
      },
    ],
    challengesEyebrow: "Vanlige utfordringer",
    servicesTitle: "Hva du kan kjøpe",
    servicesSubtitle:
      "Tjenestene er pakket som konkrete software- og dataleveranser med tydelig sluttprodukt.",
    seeService: "Se tjenesten",
    productsEyebrow: "Produkter i drift",
    productsTitle: "Kjøreklare løsninger med samme leveransemodell",
    productsSubtitle:
      "Styringsdata, booking og fakturaflyt pakket som standardiserte løsninger – med live demo og tydelig vei til kjøp.",
    productsPrimaryCta: "Se produkter",
    productsDemoCta: "Åpne demo",
    servicesEyebrow: "Tjenester",
    processEyebrow: "Arbeidsmodell",
    casesEyebrow: "Leveranser",
    faqEyebrow: "Spørsmål og svar",
    midCtaTitle: "Usikker på hvor du bør starte?",
    caseLabels: { problem: "Utfordring", solution: "Løsning", result: "Resultat" },
    closingTitle: "Book en prat",
    closingDescription:
      "Fortell hva som skaper mest friksjon i dag, så får du et konkret forslag til hva som bør ryddes opp først.",
    closingTrust: "Svar innen én virkedag.",
    primaryCta: "Book en prat",
    secondaryCta: "Se case",
  },
  en: {
    trustStrip: [
      "Founder-led delivery",
      "Reply within one business day",
      "Org. no. 934 134 176",
      "Based in Oslo",
    ],
    problemsTitle: "What VImplement makes manageable",
    problemsSubtitle:
      "The best engagements start with operations: which steps take time, which numbers are missing, and where software or AI should take over without adding complexity.",
    problems: [
      {
        icon: "repeat",
        title: "Too much manual follow-up",
        description:
          "Inquiries, quotes, documents, booking, and follow-up often live in email, spreadsheets, and memory. VImplement builds workflows where ownership, logging, and next steps are clear.",
      },
      {
        icon: "chart",
        title: "The numbers are fragmented",
        description:
          "Leaders need margin, cash flow, pipeline, capacity, and deviations in one decision layer. VImplement connects the sources and makes the numbers usable day to day.",
      },
      {
        icon: "link",
        title: "Your systems do not work together",
        description:
          "Website, CRM, finance, documents, and internal routines need to fit together. The goal is a cleaner operating surface, not another system nobody owns.",
      },
    ],
    processTitle: "How engagements are delivered",
    processSubtitle:
      "Small and mid-sized deliveries with clear scope, measurable value, and direct access to the person building the solution.",
    process: [
      {
        step: "01",
        title: "Assessment",
        description:
          "We review process, data sources, ownership, and bottlenecks. The goal is to find where software, data, or AI creates value first.",
      },
      {
        step: "02",
        title: "Solution outline",
        description:
          "You get a concrete proposal covering scope, integrations, risk, and what should be measured after go-live.",
      },
      {
        step: "03",
        title: "Implementation",
        description:
          "The solution is built, connected, and documented with a focus on operations, security, ownership, and clean handover.",
      },
      {
        step: "04",
        title: "Stabilization",
        description:
          "After launch, the solution is adjusted based on actual usage rather than assumptions. That makes it stronger over time.",
      },
    ],
    casesTitle: "Examples of deliveries",
    casesSubtitle:
      "Typical engagements where VImplement combines AI, management data, and practical software for Norwegian SMBs.",
    caseStudies: [
      {
        title: "Finance environment with too much manual VAT handling",
        problem:
          "Transactions had to be categorized and checked manually before reporting.",
        solution:
          "Automated categorization, API integration with the finance system, and a cleaner control flow before submission.",
        result:
          "Hours saved every week and better reporting control.",
      },
      {
        title: "Leadership team missing one decision layer",
        problem:
          "Revenue, cost, and operating data lived across multiple systems and spreadsheets.",
        solution:
          "Built a Power BI leadership dashboard with clear KPIs and a structured data model.",
        result:
          "Faster decisions and less time spent assembling reports manually.",
      },
      {
        title: "Service business with outdated booking and lead flow",
        problem:
          "Customer dialogue and bookings arrived through phone, forms, and email without a shared process.",
        solution:
          "New website, digital booking, and structured follow-up connected to back-office routines.",
        result:
          "More digital inquiries and less day-to-day admin friction.",
      },
    ],
    faqTitle: "Frequently asked questions",
    faqSubtitle:
      "Short answers to what most companies want to know before a first conversation.",
    faq: [
      {
        question: "Who is VImplement best suited for?",
        answer:
          "Typically Norwegian SMBs with manual administration, weak reporting, friction in customer handling, or finance and operations data that does not connect well enough.",
      },
      {
        question: "How quickly can an engagement start?",
        answer:
          "It depends on scope, but smaller assessments and clearly bounded deliveries can often start quickly. The first step is a short conversation about needs, systems, and desired outcomes.",
      },
      {
        question: "Is this software or consulting hours?",
        answer:
          "Both, but packaged as concrete deliveries. The goal is a working workflow, reporting surface, or software component, not loose hours without a clear end product.",
      },
      {
        question: "Does VImplement only work with Microsoft technology?",
        answer:
          "Microsoft is often a natural starting point, but the solution is adapted to the systems you already use. The goal is not to force a specific stack.",
      },
      {
        question: "Can VImplement help with both strategy and delivery?",
        answer:
          "Yes. Many engagements start with prioritization and continue into implementation, documentation, and stabilization.",
      },
    ],
    challengesEyebrow: "Common challenges",
    servicesTitle: "What you can buy",
    servicesSubtitle:
      "The services are packaged as concrete software and data deliveries with a clear end product.",
    seeService: "See service",
    productsEyebrow: "Products in operation",
    productsTitle: "Ready-to-run solutions with the same delivery model",
    productsSubtitle:
      "Management data, booking, and invoicing flows packaged as standardized solutions — with live demos and a clear path to purchase.",
    productsPrimaryCta: "See products",
    productsDemoCta: "Open demo",
    servicesEyebrow: "Services",
    processEyebrow: "How we work",
    casesEyebrow: "Deliveries",
    faqEyebrow: "Questions and answers",
    midCtaTitle: "Not sure where to start?",
    caseLabels: { problem: "Challenge", solution: "Solution", result: "Result" },
    closingTitle: "Book a call",
    closingDescription:
      "Tell us what creates the most friction today, and you will get a concrete suggestion for what should be fixed first.",
    closingTrust: "Reply within one business day.",
    primaryCta: "Book a call",
    secondaryCta: "See case studies",
  },
};

export const pageCopy = {
  no: {
    home: {
      title: "VImplement | AI, data og operativ software for norske SMB-er",
      description:
        "AI-arbeidsflyter, styringsdata, Microsoft Fabric-datalag og operativ software for norske SMB-er. Book en prat.",
    },
    services: {
      title: "Tjenester | VImplement",
      description:
        "Produktiserte leveranser: AI-arbeidsflyt, styringsdata, Microsoft Fabric, økonomiflyt og interne verktøy for norske SMB-er.",
    },
    cases: {
      title: "Case | VImplement",
      description:
        "Eksempler på automatisering, rapportering, booking og digitale arbeidsflyter for norske virksomheter.",
    },
    about: {
      title: "Om VImplement | Grunnlegger-ledet AI, data og software",
      description:
        "Victor Berg hjelper norske SMB-er med praktisk AI, styringsdata og operativ software – levert direkte uten mellomledd.",
    },
    contact: {
      title: "Kontakt | Book en prat",
      description:
        "Beskriv prosessen, rapporteringen eller kundeflyten du vil forbedre. Svar innen én virkedag.",
    },
    book: {
      title: "Book en prat | VImplement",
      description:
        "Book en kort samtale på 20–30 minutter direkte med grunnleggeren. Du får et konkret forslag til neste steg – svar innen én virkedag.",
    },
    privacy: {
      title: "Personvern | VImplement",
      description:
        "Les hvordan vi behandler kontaktopplysninger og henvendelser fra nettsiden.",
    },
    products: {
      title: "Produkter | Styringsdata, Bookingflyt og Fakturaflyt | VImplement",
      description:
        "Ferdige løsninger for norske SMB-er: Power BI-dashbord, automatisert booking og EHF/e-faktura. Forutsigbar månedspris, i drift på dager.",
    },
  },
  en: {
    home: {
      title: "VImplement | AI, data, and operational software for Norwegian SMBs",
      description:
        "VImplement builds AI workflows, management data, Microsoft Fabric data layers, and operational software for Norwegian SMBs. Book a call.",
    },
    services: {
      title: "Services | VImplement",
      description:
        "Productized services spanning AI workflows, management data, Microsoft Fabric, finance flows, and internal tools for Norwegian SMBs.",
    },
    cases: {
      title: "Case studies | VImplement",
      description:
        "Examples of deliveries across automation, reporting, booking, and digital operations for Norwegian businesses.",
    },
    about: {
      title: "About VImplement | Founder-led AI, data, and software",
      description:
        "Victor Berg helps Norwegian SMBs with practical AI, management data, and operational software through direct delivery.",
    },
    contact: {
      title: "Contact | Book a call",
      description:
        "Describe the process, reporting, or customer flow you want to improve. VImplement replies within one business day.",
    },
    book: {
      title: "Book a call | VImplement",
      description:
        "Book a short 20–30 minute call directly with the founder. You get a concrete suggested next step — reply within one business day.",
    },
    privacy: {
      title: "Privacy | VImplement",
      description:
        "Read how VImplement processes contact details and inquiries submitted through the website.",
    },
    products: {
      title: "Products | Power BI dashboards, booking, and e-invoicing | VImplement",
      description:
        "Ready-made solutions for Norwegian SMBs: Power BI dashboards, automated booking, and EHF/e-invoicing. Fixed pricing, live in days.",
    },
  },
};
